import CardUpImg from "../../../assets/svg/nz-bg-card-up-white.svg";
import NZContact from "../../../components/NZComponent/home/NZContact/NZContact";
import HomeIcon from "../../../assets/svg/HomeIcon.svg";
import RightSideArrow from "../../../assets/svg/RightSideArrow.svg";
import { useNavigate } from "react-router";
import GeoffHill from "../../../assets/png/Geoff - Shanghai (Portrait).jpg";
import QingmeiPang from "../../../assets/png/QingmeiPang.png";
import MichelleMorton from "../../../assets/png/Michelle Morton.jpeg";
import NZGregFarrier from "../../../components/NZComponent/home/NZGregFarrier/NZGregFarrier";
import NZGregAssociates from "../../../components/NZComponent/home/NZGregAssociates/NZGregAssociates";
import BgImageSrc from "../../../assets/png/Tuatara1000Presentation.png";
import User_Icon from "../../../assets/png/User_Icon.png";
import SEOMetadata from "../../../components/SEOMetadata";
import { seoConfig } from "../../../config/seoConfig";

const NzAbout = () => {
  const seoData = seoConfig.nz.about;
  let navigate = useNavigate();

  return (
    <>
      <SEOMetadata
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
      />
      <div>
        <div className="px-[12px] py-[6px] bg-[#F0F0F0] flex items-center">
          <img
            src={HomeIcon}
            alt="HomeIcon"
            className="cursor-pointer"
            onClick={() => navigate("/")}
          />
          <div className="flex items-center mx-[5px]">
            <img src={RightSideArrow} alt="RightSideArrow" />
            <img src={RightSideArrow} alt="RightSideArrow" />
          </div>
          <div className="text-[14px] leading-[24px] text-[#383838] montserrat-semi-bold">{`About`}</div>
        </div>
        <div className="w-full bg-fixed bg-cover bg-center">
          {" "}
          <div className="w-full flex items-center justify-center">
            <div
              className="text-white kuunari-bold 
              text-[40px] 
              md:text-[80px] 
              lg:text-[120px]  py-[68px] max-w-[1127px] text-center"
              style={{
                textShadow: "2px 4px 6px #000000",
              }}
            >
              ABOUT US
            </div>
          </div>
          <img src={CardUpImg} className="w-full" />
        </div>

        <div className="bg-[#fff]">
          <div className="custom-container py-[50px]">
            <div className="max-w-[1160px] text-center mx-auto">
              <div className="kuunari-bold text-[40px] leading-[48px] sm:text-[50px] sm:leading-[60px] md:text-[60px] md:leading-[72px] lg:text-[70px] lg:leading-[85px] xl:text-[78px] xl:leading-[91px] text-[#333333]">
                OVER 18 YEARS OF INDUSTRY EXPERIENCE
              </div>
              <div className="mt-[16px] md:mt-[20px]">
                <p className="text-left text-[#666666] montserrat-medium text-[14px] leading-[24px] sm:text-[16px] sm:leading-[28px] md:text-[18px] md:leading-[32px] lg:text-[20px] lg:leading-[36px]">
                  If you're looking to purchase a UTV (
                  <span className="text-[#AF8600]">
                    ie. Off-road utility vehicle
                  </span>
                  ), the team at Tuatara have the expert knowledge to help you.
                </p>
              </div>
              <br />
              <div className="mt-[16px] md:mt-[20px]">
                <p className="text-left text-[#666666] montserrat-medium text-[14px] leading-[24px] sm:text-[16px] sm:leading-[28px] md:text-[18px] md:leading-[32px] lg:text-[20px] lg:leading-[36px]">
                  <strong className="text-[#000]">
                    Geoff Hill and Qingmei Pang
                  </strong>{" "}
                  are the creators of the Tuatara side-by-side. Geoff has been
                  importing and selling a range of agricultural machinery for
                  over 18 years, but approximately 12 years ago, he changed tack
                  to concentrate on the Tuatara UTV and has not looked back.
                  Qingmei is a qualified mechanical engineer as well as having
                  qualifications in international business. Together they have
                  designed and developed the Tuatara UTV specifically for the
                  New Zealand market. However, in recent times the Company has
                  expanded into the international arena, with exports to
                  Australia, the USA, Canada and Europe. It seems that these
                  markets also appreciate Kiwi design.
                </p>
              </div>
              <br />
              <div className="mt-[16px] md:mt-[20px]">
                <p className="text-left text-[#666666] montserrat-medium text-[14px] leading-[24px] sm:text-[16px] sm:leading-[28px] md:text-[18px] md:leading-[32px] lg:text-[20px] lg:leading-[36px]">
                  <strong className="text-[#000]">
                    So why the Tuatara name?
                  </strong>{" "}
                  The Tuatara reptile is iconic to New Zealand, so it’s a
                  well-known brand, and it’s been around for a million or so
                  years, it can live for well over 100 years. So, its definitely
                  got endurance and longevity. Furthermore, the Tuatara has got
                  that rugged charm about it, that makes it appealing, and so
                  does the Tuatara UTV. So, this is why we decided upon the
                  “Tuatara” brand name, and the interesting thing is that even
                  in Australia, Canada, Europe and the USA, the Tuatara brand
                  has been exceptionally well received.
                </p>
              </div>

              <br />
              <div className="mt-[16px] md:mt-[20px]">
                <p className="text-left text-[#666666] montserrat-medium text-[14px] leading-[24px] sm:text-[16px] sm:leading-[28px] md:text-[18px] md:leading-[32px] lg:text-[20px] lg:leading-[36px]">
                  <strong className="text-[#000]">
                    So why the Tuatara vehicle?
                  </strong>{" "}
                  During the early time of the agricultural machinery business,
                  Geoff repeatedly noted comments from farmers, complaining
                  about the maintenance costs on their existing side-by-sides.
                  They were unhappy about the fact that a high proportion of the
                  construction was plastic, that overtime would crack and break.
                  They were also unhappy about the frequency of breakdowns and
                  the high cost of parts and repairs. It struck Geoff that there
                  might be a market for a purpose-built side-by-side, built
                  especially for the New Zealand market. And so, this is where
                  the Tuatara was born, an all-steel side-by-side that can carry
                  and tow more and outperform its competition in terms of where
                  it can go.
                </p>
              </div>
            </div>
            <div className="max-w-[930px] text-center mx-auto px-4">
              <div className="kuunari-bold text-[32px] leading-[40px] sm:text-[40px] sm:leading-[48px] md:text-[50px] md:leading-[60px] lg:text-[60px] lg:leading-[72px] xl:text-[70px] xl:leading-[85px] text-[#333333] my-[50px] sm:my-[70px]">
                Meet The Team
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-[20px] sm:gap-[30px] md:gap-[40px]">
                <div className="flex items-center justify-start flex-col text-center">
                  <div className="flex items-center w-[-webkit-fill-available]">
                    <img
                      src={GeoffHill}
                      alt="Geoff Hill"
                      className="max-h-[190px] object-cover w-full"
                    />
                  </div>
                  <div className="kuunari-bold text-[20px] sm:text-[24px] leading-[40px] text-[#333333]">
                    Geoff Hill
                  </div>
                  <div className="montserrat-medium text-[14px] sm:text-[16px] leading-[24px] text-[#666666]">
                    NZ Sales Manager
                  </div>
                  <a
                    href="mailto:geoff@tuataraatv.com"
                    className="montserrat-medium text-[14px] sm:text-[16px] leading-[24px] text-[#666666]"
                  >
                    <span className="text-[#F7871B]">geoff@tuataraatv.com</span>
                  </a>
                </div>

                <div className="flex items-center justify-start flex-col text-center">
                  <div className="flex items-center">
                    <img src={QingmeiPang} alt="Qingmei Pang" />
                  </div>
                  <div className="kuunari-bold text-[20px] sm:text-[24px] leading-[40px] text-[#333333]">
                    Qingmei Pang
                  </div>
                  <div className="montserrat-medium text-[14px] sm:text-[16px] leading-[24px] text-[#666666]">
                    Technical Manager
                  </div>
                  <a
                    href="mailto:qingmei@tuataraatv.com"
                    className="montserrat-medium text-[14px] sm:text-[16px] leading-[24px] text-[#666666]"
                  >
                    <span className="text-[#F7871B]">
                      qingmei@tuataraatv.com
                    </span>
                  </a>
                </div>

                <div className="flex items-center justify-start flex-col text-center">
                  <div className="flex items-center">
                    <img src={MichelleMorton} alt="Michelle Morton" />
                  </div>
                  <div className="kuunari-bold text-[20px] sm:text-[24px] leading-[40px] text-[#333333]">
                    Michelle Morton
                  </div>
                  <div className="montserrat-medium text-[14px] sm:text-[16px] leading-[24px] text-[#666666]">
                    Parts Manager
                  </div>
                  <a
                    href="mailto:office@tuataraatv.com"
                    className="montserrat-medium text-[14px] sm:text-[16px] leading-[24px] text-[#666666]"
                  >
                    <span className="text-[#F7871B]">
                      office@tuataraatv.com
                    </span>
                  </a>
                </div>

                <div className="flex items-center justify-start flex-col text-center">
                  <div className="flex items-center">
                    <img src={User_Icon} alt="Kelly Sumner" />
                  </div>
                  {/* <div className="kuunari-bold text-[20px] sm:text-[24px] leading-[40px] text-[#333333]">
                    Kelly Sumner
                  </div> */}
                  <div className="montserrat-medium text-[14px] sm:text-[16px] leading-[24px] text-[#666666]">
                    Office and Sales Support
                  </div>
                  <a
                    href="mailto:pa@tuataraatv.com"
                    className="montserrat-medium text-[14px] sm:text-[16px] leading-[24px] text-[#666666]"
                  >
                    <span className="text-[#F7871B]">pa@tuataraatv.com</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div
          className="relative"
          style={{
            backgroundImage: `url(${BgImageSrc})`,
            backgroundSize: "cover", // Ensure the image covers the container without stretching
            backgroundPosition: "center", // Center the image within the container
            backgroundRepeat: "no-repeat", // Prevent the image from repeating
          }}
        >
          <div className="absolute inset-0 bg-black/30"></div>
          <div className="custom-container py-[50px] relative">
            <div className="max-w-[917px] text-center mx-auto md:pt-[300px] pt-[100px] md:pb-[200px] pb-[100px]">
              <div className="text-[#fff] kuunari-bold text-[44px] leading-[71px] text-start">
                The Tuatara UTV Vehicle
              </div>
              <div className="text-[#fff] montserrat-medium text-[18px] leading-[30px] text-start">
                The Tuatara ATV Off-Road Utility Vehicle (UTV) designed in New
                Zealand, is unmatched and unrivalled in features and quality in
                its class. This highly functional, amazingly robust and truly
                versatile machine is suitable for just about any application,
                including farming, horticulture, commercial uses, hunting, or
                for purely recreational purposes. In fact, its all-steel
                structure makes it probably the toughest UTV available in New
                Zealand. We export Tuatara ATVs globally and currently
                distribute them to the USA, Canada, UK, Australia, Europe, South
                America, and more. We are always happy to receive new Tuatara
                enquiries from any country.
              </div>
            </div>
          </div>
        </div> */}
        <div className="relative w-full">
          <img
            src={BgImageSrc}
            alt="Background"
            className="w-full h-[300px] sm:h-[400px] md:h-[600px] lg:h-[100%] object-cover"
          />
          <div className="absolute inset-0 bg-black/30"></div>
        </div>

        <NZGregFarrier
          bg={"#fff"}
          slogan="“THIS IS HANDS DOWN THE MOST VERSATILE ATV I HAVE PURCHASED FOR THE FARM.”"
        />

        <div id="contact-form">
          <NZContact />
        </div>
        {/* <NZGregAssociates /> */}
      </div>
    </>
  );
};
export default NzAbout;
